import React from 'react'
import cn from 'classnames'
import { observer } from 'mobx-react'

import TypeIcon from 'components/typeIcon/TypeIcon'

import treeStringify from 'utils/treeStringify'

import styles from './treeRowScalar.scss'

interface IProps {
  path: string
  isSelected: boolean
  fieldName: string
  value: string | number | boolean
  style: React.CSSProperties
  onClick: (path: string) => void

  isString: boolean
  isInt: boolean
  isFloat: boolean
  isBoolean: boolean
  isDateTime: boolean
}

const shouldShowIcon = (props: IProps) => {
  return (
    props.isString ||
    props.isInt ||
    props.isFloat ||
    props.isBoolean ||
    props.isDateTime
  )
}

class TreeRowScalar extends React.PureComponent<IProps> {
  handleClick = (e: React.FormEvent) => {
    const { path, onClick } = this.props

    e && e.stopPropagation()
    onClick(path)
  }

  render() {
    const {
      path,
      isSelected,
      fieldName,
      value,
      isString,
      isInt,
      isFloat,
      isBoolean,
      isDateTime,
      style,
    } = this.props

    const depth = path.split('::').length - 1

    return (
      <div
        data-cy="tree__scalar"
        style={style}
        className={cn(styles.container, {
          [styles.active]: isSelected,
        })}
        tabIndex={1}
        onClick={this.handleClick}
      >
        <div className={styles.depthGutter} style={{ width: depth * 16 }}></div>

        <div className={styles.meta}>
          {shouldShowIcon(this.props) && (
            <TypeIcon
              className={styles.icon}
              required
              string={isString}
              int={isInt}
              float={isFloat}
              boolean={isBoolean}
              dateTime={isDateTime}
            />
          )}

          <div className={styles.fieldName}>{fieldName}:</div>
        </div>

        <div className={styles.fieldValue}>{treeStringify(value)}</div>
      </div>
    )
  }
}

export default observer(TreeRowScalar)
